import { defineComponent, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { GoogleMapWrapper, SettingTable, SettingTableRow, BasicInput } from '@hems/component';
import { EMS_TYPE } from '@hems/util/src/constant';
export default defineComponent({
    name: 'AddressInfo',
    components: {
        GoogleMapWrapper,
        SettingTable,
        SettingTableRow,
        BasicInput,
    },
    setup() {
        const store = useStore();
        const apiKey = store.state.appCtx.googleApiKey;
        const defaultInstallationInfo = {
            device_id: '',
            site_id: 0,
            fox_box_id: '',
            pv_cap: 0,
            bat_cnt: 0,
            pem_mode: false,
            install_dt: '',
            warrenty_dt: '',
            timezone: '',
            latitude: 0,
            longitude: 0,
            address: '',
            installer_name: '',
            installer_company: '',
            installer_email: '',
            installer_tel_num: '',
            gateway_connection: false,
            product_model_nm: '',
            ems_ver: '',
            ems_type_cd: EMS_TYPE.STAND_ALONE,
        };
        const state = reactive({
            data: store.state.device.installation ?? defaultInstallationInfo,
            googleMap: null,
            google: window.google,
            lat: '',
            lng: '',
        });
        const language = computed(() => store.state.appCtx.langCd);
        function formattedValue() {
            state.lat = state.data.latitude.toFixed(6);
            state.lng = state.data.longitude.toFixed(6);
        }
        formattedValue();
        return {
            language,
            state,
            apiKey,
            instance: (instance) => {
                state.googleMap = instance.map;
            },
        };
    },
});
